<template>
  <svg aria-hidden="true" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.64648 9.91211H7.24023L7.04102 4H8.8457L8.64648 9.91211Z" fill="#CE1B04" />
    <path
      d="M7.94336 10.8379C8.22852 10.8379 8.45801 10.9219 8.63184 11.0898C8.80567 11.2578 8.89258 11.4727 8.89258 11.7344C8.89258 11.9922 8.80567 12.2051 8.63184 12.373C8.45801 12.541 8.22852 12.625 7.94336 12.625C7.66211 12.625 7.43457 12.541 7.26074 12.373C7.08691 12.2051 7 11.9922 7 11.7344C7 11.4766 7.08691 11.2627 7.26074 11.0928C7.43457 10.9229 7.66211 10.8379 7.94336 10.8379Z"
      fill="#CE1B04"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8 14.25C4.54822 14.25 1.75 11.4518 1.75 8C1.75 4.54822 4.54822 1.75 8 1.75C11.4518 1.75 14.25 4.54822 14.25 8C14.25 11.4518 11.4518 14.25 8 14.25Z"
      fill="#CE1B04"
    />
  </svg>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'TextFieldErrorIcon',
});
</script>
